import { Matrix4x4 } from "../../../../maths/Matrix4x4";
export class WebCameraNodeData {
    constructor() {
        this._projectViewMatrix = new Matrix4x4();
    }
    setProjectionViewMatrix(value) {
        value && value.cloneTo(this._projectViewMatrix);
    }
}
export class WebSceneNodeData {
}
